import { render } from "./AccessNoticeView.vue?vue&type=template&id=a3a0050e"
import script from "./AccessNoticeView.vue?vue&type=script&lang=js"
export * from "./AccessNoticeView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../../../DEV/_vue3/reactive-clinic/rc-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__